/* We use epochTime of account creation as a surrogate
for detecting whether we created a new account via google login */
import { USER_STATUS, IUser } from './auth.interfaces'

export const isNewUser = (createdMilisecondsAgo: number) => {
  // 120 seconds
  return Date.now() - createdMilisecondsAgo < 120000
}

export function getHighestTierForUser(user: IUser) {
  return user.isAdmin
    ? USER_STATUS.ADMIN
    : user.isPremium
    ? USER_STATUS.PREMIUM
    : user.loggedIn
    ? USER_STATUS.FREE
    : USER_STATUS.ANONYMOUS
}
